<template>
  <div class="ifame">
    <div class="title">
      {{$t('m.VideoOnDemand')}}
      <span @click="close" class="close"><Icon style="color:red" type="ios-close"></Icon></span>
    </div>
    <iframe frameborder="0" sameorigin src="http://www.baidu.com"></iframe>
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    props: ['src'],
    methods: {
      close() {
        this.$emit("iframeclose")
      }
    }
  }
</script>
<style scoped>
  .ifame {
    width: 100vw;
    height: 100vh;
    position: fixed;
    overflow: hidden;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10000;
  }

  .ifame > iframe {
    position: absolute;
    width: 103vw;
    height: 92vh;
    top: 8vh;
    left: 0;
  }

  .close {
    font-size: 0.3rem;
    position: absolute;
    top: 0rem;
    right: 0.05rem;
  }

  .title {
    position: absolute;
    width: 100vw;
    height: 8vh;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 8vh;
    font-size: 0.20rem;
    color: #fff;
    background: #000;
  }
</style>




// WEBPACK FOOTER //
// src/components/content/iframe.vue